import { render, staticRenderFns } from "./ObjectGroups.vue?vue&type=template&id=0e51a894&scoped=true&"
import script from "./ObjectGroups.vue?vue&type=script&lang=js&"
export * from "./ObjectGroups.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGroups.vue?vue&type=style&index=0&id=0e51a894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51a894",
  null
  
)

export default component.exports